import ActionButton from 'components/action-button';
import { BottomSheet } from 'components/bottom-sheet';
import { t } from 'state/intl/translations';

import { ContentHeader, ContentText, ContentWrapper } from './styled';

interface WalmartWelcomeProps {
  isOpen?: boolean;
  handleOnClose?: () => void;
  handleOnConfirm: () => void;
}

export const WalmartWelcome = ({
  isOpen = false,
  handleOnClose,
  handleOnConfirm,
}: WalmartWelcomeProps) => {
  return (
    <BottomSheet isOpen={isOpen} onOpenEventMessage="Walmart Welcome modal" onClose={handleOnClose}>
      <ContentWrapper>
        <ContentHeader>{t('welcome')}</ContentHeader>
        <ContentText>{t('walmartWelcomeLinkWithWalmartPlus')}</ContentText>
        <ActionButton fullWidth onPress={handleOnConfirm} mb="$4">
          {t('walmartConnectWithWalmartPlus')}
        </ActionButton>
      </ContentWrapper>
    </BottomSheet>
  );
};
